import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ElementDirection, TranslateLanguage, translateLanguages } from '@fleet-beat/libs-core/src';
import { distinctUntilChanged } from 'rxjs/operators';
import { Direction } from '@angular/cdk/bidi';

@Injectable({ providedIn: 'root' })
export class ElementDirectionService {
  get direction$(): Observable<Direction> {
    return this._direction$.asObservable().pipe(distinctUntilChanged());
  }

  private readonly _direction$: BehaviorSubject<Direction> = new BehaviorSubject<Direction>(ElementDirection.ltr);

  setDirectionByLanguage(langCode: string): void {
    const language: TranslateLanguage = translateLanguages.find((item: TranslateLanguage) => item.code === langCode);
    if (!language) {
      return;
    }

    this._direction$.next(language.elementDirection as Direction);
  }
}
